export const SecondaryButtonComponent = () => {
  return (
    <div className="h-10 w-36 md:w-44 flex justify-center items-center bg-white rounded text-lg text-primaryBlue font-newFont border border-1 border-primaryBlue">
      <a href="https://beta.auditech.app/">Ingresar</a>
    </div>
  );
};
